import { PageHeader } from "@/components/dashboard/page-header";
import { SearchList } from "@/components/dashboard/search-list";
import { ErrorState } from "@/components/dashboard/state";
import { clientApi } from "@/lib/client-api";
import { useQuery } from "@tanstack/react-query";

export function GeneralPage() {
  const {
    data = [],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["client", "searches", "general"],
    queryFn: () => clientApi.searches("general"),
  });
  return (
    <div className="animate-fade-up space-y-8">
      <PageHeader title="General" description="Manager and specialist roles outside the leadership tiers." />
      {isError ? (
        <ErrorState onRetry={() => refetch()}>Couldn't load these roles.</ErrorState>
      ) : (
        <SearchList rows={data} loading={isLoading} />
      )}
    </div>
  );
}
